module.exports = __webpack_public_path__ + "img/mobile-search-en.54b2bd0.png";